<template>
  <div>
    <hardware-form operation="unbind"></hardware-form>
  </div>
</template>

<script>
import HardwareForm from './components/hardware-form'

export default {
  name: 'hardware-unbind',

  components: {
    HardwareForm
  }
}
</script>

